import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-page-success',
  templateUrl: './confirmation-page-success.component.html',
  styleUrls: ['./confirmation-page-success.component.scss']
})
export class ConfirmationPageSuccessComponent {

  @Input('action') action: string;
  @Input('description') description: string;
  @Input('descriptionline') descriptionline: string;

  @Input('button1Text') button1Text: string;
  @Input('button2Text') button2Text: string;
  @Input('button3Text') button3Text: string;
  @Input('button4Text') button4Text: string;

  @Output('button1click') button1click: EventEmitter<any> = new EventEmitter();
  @Output('button2click') button2click: EventEmitter<any> = new EventEmitter();
  @Output('button3click') button3click: EventEmitter<any> = new EventEmitter();
  @Output('button4click') button4click: EventEmitter<any> = new EventEmitter();
  constructor() { }

  onButton1Click() {
    this.button1click.emit(null);
  }

  onButton2Click() {
    this.button2click.emit(null);
  }

  onButton3Click() {
    this.button3click.emit(null);
  }
  onButton4Click() {
    this.button4click.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/confirmation-page-success/confirmation-page-success.component.ts